import Lenis from 'lenis';

// リロード時のスクロール位置復元を無効化してページ上部から開始
history.scrollRestoration = 'manual';
window.scrollTo(0, 0);

const lenis = new Lenis({ autoRaf: true });

// l-loader: 全リソース読み込み完了で消える。ただし5秒経過したら強制的にフェードアウト
// onLoaderHidden(callback): ローダーが消えたタイミングで実行したい処理を登録する
// (ページ読み込み演出は、ローダーが完全に消えるまで開始してはいけないため)
const loader = document.querySelector('.l-loader');
let onLoaderHidden = (callback) => callback();

if (loader) {
  const LOADER_MAX_WAIT = 5000;
  let isLoaderHidden = false;
  const hiddenCallbacks = [];

  const hideLoader = () => {
    if (isLoaderHidden) return;
    isLoaderHidden = true;
    loader.classList.add('is-hidden');
    hiddenCallbacks.splice(0).forEach((callback) => callback());
  };

  onLoaderHidden = (callback) => {
    if (isLoaderHidden) {
      callback();
    } else {
      hiddenCallbacks.push(callback);
    }
  };

  window.addEventListener('load', hideLoader);
  setTimeout(hideLoader, LOADER_MAX_WAIT);
}

// スクロールに合わせてtop-intro__clip-wrapのclip-pathを更新
lenis.on('scroll', () => {
  const clipWrap = document.querySelector('.top-intro__clip-wrap');
  if (!clipWrap) return;

  const vh = window.innerHeight;
  const top = clipWrap.getBoundingClientRect().top;

  const start = vh * 0.9;
  const end = vh * 0.2;
  const progress = Math.min(1, Math.max(0, (start - top) / (start - end)));

  clipWrap.style.setProperty('--clip-x', `${5 * (1 - progress)}%`);
});

// c-parallax: 外枠は通常のスクロール位置のまま、中のimgだけ速度を変えて奥行きを出す
// c-parallax-bg: background-imageで表示している要素向け(imgを持たないセクション背景用)
// 速度を変えたい要素には data-parallax-speed="1.5" のように指定する（未指定は1）
const PARALLAX_RANGE = 60; // px

function getParallaxY(frame, vh, speed) {
  const rect = frame.getBoundingClientRect();
  const center = rect.top + rect.height / 2;

  // ビューポート中央を0とした-1〜1の進捗(中央を通過するタイミングでズレなし)
  const progress = Math.min(
    1,
    Math.max(-1, (vh / 2 - center) / (vh / 2 + rect.height / 2)),
  );

  return `${progress * PARALLAX_RANGE * speed}px`;
}

function updateParallax() {
  const vh = window.innerHeight;

  document.querySelectorAll('.c-parallax').forEach((frame) => {
    const image = frame.querySelector('img');
    if (!image) return;

    const speed = Number(frame.dataset.parallaxSpeed) || 1;
    image.style.setProperty('--parallax-y', getParallaxY(frame, vh, speed));
  });

  document.querySelectorAll('.c-parallax-bg').forEach((frame) => {
    const speed = Number(frame.dataset.parallaxSpeed) || 1;
    frame.style.setProperty('--parallax-y', getParallaxY(frame, vh, speed));
  });
}

lenis.on('scroll', updateParallax);
updateParallax(); // 初回描画時点(スクロール前)でも位置を計算しておく

// c-area-list: ホバーでそのエリア内の背景画像を表示し、マウス位置と逆方向に画像をずらす + カスタムカーソル
const AREA_BG_RANGE = 30; // px

const areaCursor = document.querySelector('.c-area-list__cursor');

// c-fade-inなどtransformを持つ祖先の中に配置されると、position: fixedの基準がその祖先に
// 変わってしまい(スクロールに追従する・座標がズレる)、body直下に移すことでviewport基準を保証する
if (areaCursor) {
  document.body.appendChild(areaCursor);
}

document.querySelectorAll('.c-area-list__link').forEach((link) => {
  const bgImage = link.querySelector('.c-area-list__bg img');

  link.addEventListener('mouseenter', (event) => {
    // mousemoveを待たずに現在位置へ即座にセットしないと、直前にカーソルがあった
    // 座標から現在のホバー位置へジャンプして見えてしまう(Windowsで顕著)
    if (areaCursor) {
      areaCursor.style.left = `${event.clientX}px`;
      areaCursor.style.top = `${event.clientY}px`;
    }
    areaCursor?.classList.add('is-active');
  });

  link.addEventListener('mouseleave', () => {
    areaCursor?.classList.remove('is-active');
  });

  link.addEventListener('mousemove', (event) => {
    const rect = link.getBoundingClientRect();
    const ratioX = (event.clientX - rect.left) / rect.width;
    const ratioY = (event.clientY - rect.top) / rect.height;

    // マウスと逆方向に画像を動かす(右下にマウスがあれば画像は左上へ)
    const offsetX = -(ratioX - 0.5) * 2 * AREA_BG_RANGE;
    const offsetY = -(ratioY - 0.5) * 2 * AREA_BG_RANGE;
    bgImage?.style.setProperty('--area-bg-x', `${offsetX}px`);
    bgImage?.style.setProperty('--area-bg-y', `${offsetY}px`);

    if (areaCursor) {
      areaCursor.style.left = `${event.clientX}px`;
      areaCursor.style.top = `${event.clientY}px`;
    }
  });
});

// top-area: 地図ピンとリストアイテムの連動
// - ピンをクリックすると対応するリストアイテムがアクティブになる(ホバー時と同じ見た目)
//   さらに、そのリストアイテムまでスムーズスクロールする(固定ヘッダー分オフセット)
// - 波紋は「ピンをクリック→アイテムにホバー→ホバー解除」の間ずっと出続ける
// - アイテムのホバーを解除すると、アクティブ状態を解除。波紋も止めるが、
//   再生中のループを中断せず最後まで再生してから止める(animationiterationで判定)
const TOP_AREA_SCROLL_OFFSET = -60; // px、固定ヘッダーの高さ分
const TOP_AREA_SCROLL_DURATION = 1.3; // 秒。ゆったりめのスクロール
// 前半は3乗(easeInCubic)、後半は5乗にして着地(止まる瞬間)をより緩やかにする
const TOP_AREA_SCROLL_EASING = (t) =>
  t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

document.querySelectorAll('.top-area__item[data-area]').forEach((item) => {
  const pin = document.querySelector(
    `.top-area__map-pin[data-area="${item.dataset.area}"]`,
  );
  if (!pin) return;

  let shouldRipple = false;

  const startRipple = () => {
    shouldRipple = true;
    pin.classList.add('is-rippling');
  };

  // 即座にis-ripplingを外さず、今のループが終わるanimationiterationまで待つ
  pin.addEventListener('animationiteration', () => {
    if (!shouldRipple) {
      pin.classList.remove('is-rippling');
    }
  });

  pin.addEventListener('click', () => {
    document
      .querySelectorAll('.top-area__item[data-area]')
      .forEach((otherItem) => {
        otherItem.classList.toggle('is-active', otherItem === item);
      });
    startRipple();
    lenis.scrollTo(item, {
      offset: TOP_AREA_SCROLL_OFFSET,
      duration: TOP_AREA_SCROLL_DURATION,
      easing: TOP_AREA_SCROLL_EASING,
    });
  });

  item.addEventListener('mouseenter', startRipple);

  item.addEventListener('mouseleave', () => {
    item.classList.remove('is-active');
    shouldRipple = false;
  });
});

const topBody = document.querySelector('.top-body');

// top-hero: top-bodyの上端が画面上端に到達したらsticky解除(逆にスクロールで戻ったら再度sticky)
// top-bodyに完全に覆われた後もsticky(position:sticky)のまま残り続けるのを防ぐ
const topHero = document.querySelector('.top-hero');

if (topHero && topBody) {
  const updateTopHeroSticky = () => {
    topHero.classList.toggle(
      'is-covered',
      topBody.getBoundingClientRect().top <= 0,
    );
  };

  lenis.on('scroll', updateTopHeroSticky);
  updateTopHeroSticky(); // 初回描画時点でも判定しておく
}

// l-header: 重なっている背景色に応じてナビのテキスト/アイコン色を切り替える
// data-header-theme="dark" を付けたセクションと重なっている間は白、それ以外(白背景想定)は$color-black
const header = document.querySelector('.l-header');
const darkThemeSections = document.querySelectorAll(
  '[data-header-theme="dark"]',
);

if (header) {
  const HEADER_REFERENCE_Y = 40; // ヘッダー内で背景色を判定する基準点(px)

  const updateHeaderTheme = () => {
    // top-body(通常フロー)がまだヘッダー位置まで被さってきていない間は、
    // その下にあるtop-hero(緑・sticky)が見えている
    const isHeroVisible =
      !!topBody && topBody.getBoundingClientRect().top > HEADER_REFERENCE_Y;

    const isOnDarkSection = Array.from(darkThemeSections).some((section) => {
      const rect = section.getBoundingClientRect();
      return (
        rect.top <= HEADER_REFERENCE_Y && rect.bottom >= HEADER_REFERENCE_Y
      );
    });

    header.classList.toggle('is-on-dark', isHeroVisible || isOnDarkSection);
  };

  lenis.on('scroll', updateHeaderTheme);
  updateHeaderTheme(); // 初回描画時点でも判定しておく
}

// l-header__menu-button: モバイル用ハンバーガーメニューの開閉
// l-header__overlay: 開いている間、薄い黒のオーバーレイをタップしても閉じる
const headerMenuButton = document.querySelector('.l-header__menu-button');
const headerOverlay = document.querySelector('.l-header__overlay');

if (header && headerMenuButton) {
  const setMenuOpen = (isOpen) => {
    header.classList.toggle('is-menu-open', isOpen);
    headerMenuButton.setAttribute('aria-expanded', String(isOpen));
    headerMenuButton.setAttribute(
      'aria-label',
      isOpen ? 'メニューを閉じる' : 'メニューを開く',
    );
    document.body.classList.toggle('is-menu-open', isOpen);
  };

  headerMenuButton.addEventListener('click', () => {
    setMenuOpen(!header.classList.contains('is-menu-open'));
  });

  headerOverlay?.addEventListener('click', () => {
    setMenuOpen(false);
  });
}

// l-header__logo: front-page限定。top-introの上端が画面上端に到達したらロゴをフェードインする
// (front-page以外にはtop-introが存在しないため、このブロックは何もしない)
const headerLogo = document.querySelector('.l-header__logo');
const topIntro = document.querySelector('.top-intro');

if (headerLogo && topIntro) {
  const updateHeaderLogoVisibility = () => {
    headerLogo.classList.toggle(
      'is-visible',
      topIntro.getBoundingClientRect().top <= 0,
    );
  };

  lenis.on('scroll', updateHeaderLogoVisibility);
  updateHeaderLogoVisibility();
}

// top-hero__logo: front-page限定。top-introの上端が画面下部30%のライン
// (=画面上から70%の位置)まで来たら、heroロゴをフェードアウトする
const heroLogo = document.querySelector('.top-hero__logo');
const HERO_LOGO_FADE_OUT_RATIO = 0.7; // 画面上からの割合

if (heroLogo && topIntro) {
  const updateHeroLogoFadeOut = () => {
    const threshold = window.innerHeight * HERO_LOGO_FADE_OUT_RATIO;
    heroLogo.classList.toggle(
      'is-fading-out',
      topIntro.getBoundingClientRect().top <= threshold,
    );
  };

  lenis.on('scroll', updateHeroLogoFadeOut);
  updateHeroLogoFadeOut();
}

// c-fade-in: 下からフェードインする汎用アニメーション(主にsection要素に付与する)
// 要素の上端が画面下からdata-fade-offset(既定20)%のラインを越えたタイミングで発火する。
// 例: data-fade-offset="10" を付けると画面下10%のラインまで待たずに発火する(既定より早め)。
// data-fade-trigger="immediate" を付けた要素は、スクロール位置に関わらず
// (ロゴアニメーションがあればその完了を待って)即座に発火する。
// ロゴアニメーションがあるページ(TOPページ)ではそれが完了してから有効化し、
// ない場合はロゴの処理を無視してすぐに有効化する
const FADE_IN_DEFAULT_OFFSET = 20; // %

function initScrollFadeIn() {
  const targets = document.querySelectorAll(
    '.c-fade-in:not([data-fade-trigger="immediate"])',
  );
  if (!targets.length) return;

  // rootMarginはobserverごとに固定のため、data-fade-offsetの値ごとにobserverを分ける
  const groups = new Map();
  targets.forEach((target) => {
    const offset = Number(target.dataset.fadeOffset) || FADE_IN_DEFAULT_OFFSET;
    if (!groups.has(offset)) groups.set(offset, []);
    groups.get(offset).push(target);
  });

  groups.forEach((groupTargets, offset) => {
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        });
      },
      { rootMargin: `0px 0px -${offset}% 0px` },
    );

    groupTargets.forEach((target) => observer.observe(target));
  });
}

function initImmediateFadeIn() {
  document
    .querySelectorAll('.c-fade-in[data-fade-trigger="immediate"]')
    .forEach((target) => {
      target.classList.add('is-visible');
    });
}

const logo = document.querySelector('.top-hero__logo');

if (logo) {
  // ローダーが消えてから 「hero logo → top-body → header nav」の順でアニメーション開始
  const LOGO_FADE_DELAY = 100;
  const LOGO_DURATION = 100; // _top.scssのtransition durationと合わせる
  const CONTENT_REVEAL_GAP = 1000; // ロゴ表示からtop-body表示までの間隔
  const NAV_REVEAL_DELAY = 1000; // top-body表示のさらに後にヘッダーナビ・l-noticeを表示するまでの間隔

  onLoaderHidden(() => {
    // ① ロゴをフェードイン
    setTimeout(() => {
      logo.classList.add('is-visible');
    }, LOGO_FADE_DELAY);

    // ② ロゴのアニメーション完了後にtop-body側のc-fade-in、top-bodyのせり上がりを有効化
    const fadeInDelay = LOGO_FADE_DELAY + LOGO_DURATION + CONTENT_REVEAL_GAP;
    setTimeout(() => {
      initScrollFadeIn();
      initImmediateFadeIn();
      topBody?.classList.add('is-visible');
    }, fadeInDelay);

    // ③ 最後にヘッダーナビ・l-notice(TOPでは初期非表示)を表示
    setTimeout(() => {
      header?.classList.add('is-nav-visible');
      document.querySelector('.l-notice')?.classList.add('is-visible');
    }, fadeInDelay + NAV_REVEAL_DELAY);
  });
} else {
  // ロゴアニメーションがないページも、ローダーが消えてから有効化
  onLoaderHidden(() => {
    initScrollFadeIn();
    initImmediateFadeIn();
  });
}

// l-notice: 全ページ共通・画面右下のお知らせ。×で閉じたらそのセッション中は再表示しない
const NOTICE_SESSION_KEY = 'onsen-journey-notice-closed';
const notice = document.querySelector('.l-notice');

if (notice) {
  if (sessionStorage.getItem(NOTICE_SESSION_KEY) === '1') {
    notice.hidden = true;
  }

  notice
    .querySelector('[data-notice-close]')
    ?.addEventListener('click', () => {
      notice.hidden = true;
      sessionStorage.setItem(NOTICE_SESSION_KEY, '1');
    });
}

// [data-more-list]: SP限定で最初はdata-more-step件だけ表示し、
// 直後の[data-more-trigger]ボタンをタップするたびにstep件ずつ追加表示する。
// 全件表示し終えたらボタンを隠す。件数がstep以下ならボタンは最初から出さない。
// PC(md以上)では常に全件表示し、ボタンも常に非表示。
const MORE_LIST_BREAKPOINT = '(min-width: 768px)'; // foundation/_variable.scssのbreakpoints.mdと合わせる

document.querySelectorAll('[data-more-list]').forEach((list) => {
  const button = list.nextElementSibling;
  if (!button || !button.matches('[data-more-trigger]')) return;

  const step = Number(list.dataset.moreStep) || 6;
  const items = Array.from(list.children);
  let visibleCount = step;

  const update = () => {
    if (window.matchMedia(MORE_LIST_BREAKPOINT).matches) {
      items.forEach((item) => {
        item.hidden = false;
      });
      button.hidden = true;
      return;
    }

    items.forEach((item, index) => {
      const shouldShow = index < visibleCount;
      if (shouldShow && item.hidden) {
        // 非表示→表示になる項目だけフェードインさせる(既に表示中の項目は対象外)
        item.hidden = false;
        item.classList.add('is-revealing');
      } else if (!shouldShow) {
        item.hidden = true;
        item.classList.remove('is-revealing');
      }
    });
    button.hidden = items.length <= step || visibleCount >= items.length;
  };

  button.addEventListener('click', () => {
    visibleCount += step;
    update();
  });

  window.addEventListener('resize', update);
  update();
});
